<!-- To apply a background color to the SVG, add [ngClass]="colorType" to the <span> element -->
<div class="container">
    @if (svg) {
        <span class="icon" [innerHTML]="svg"></span>
    }
    <p>{{ text }}</p>
</div>
